import React, { useState, useEffect, useRef } from 'react';
import PlayerBox from "./PlayerBox.js"
import { getGameInfo, emptyBoard, blankMap, HORIZONTALCOORDS } from './App.js';
import BoundedGoban from "./shudan/BoundedGoban.js";
import NavigationBar from "./NavigationBar.js";
import { parseVertex, parseCompressedVertices } from '@sabaki/sgf'
import Board from "@sabaki/go-board";


const sgf = require('@sabaki/sgf')
const GameTree = require('@sabaki/immutable-gametree')


const SGFSTRING="(;FF[4]CA[UTF-8]GM[1]GN[Parx]PC[https://online-go.com/review/1408009]PB[Black]PW[White]BR[3p]WR[3p]OT[Error: time control missing]RE[?]SZ[19]KM[6.5]RU[Japanese];B[pd];W[dq];B[pp];W[dd];B[co];W[ep];B[cf];W[fc];B[bd];W[cc](;B[cj])(;B[ci];W[qn];B[nq];W[qp];B[qq];W[rq];B[qo];W[rp];B[ro](;W[pq];B[op])(;W[po];B[rn];W[pq];B[op];W[pr];B[qm];W[qf];B[nc];W[rd];B[qc];W[qi];B[hq];W[cm];B[dm];W[dl];B[dn];W[ck];B[cq];W[cp];B[bp];W[dp];B[bq];W[em];B[el];W[ek];B[fl];W[en];B[cn];W[bm];B[dr];W[do];B[bo];W[er];B[cr];W[fo];B[fq];W[gm];B[eq];W[fp];B[gp];W[fk];B[go];W[gn];B[jd];W[bc];B[cd];W[bj];B[bi];W[pn];B[pm];W[on];B[nl];W[mn];B[om];W[nm];B[mm];W[nn];B[lq];W[lm];B[ml];W[mp];B[mq];W[ln];B[hl];W[gl];B[in];W[ll];B[ni];W[ol](;B[pk])(;B[ok];W[pl];B[pk];W[ql];B[qk];W[rm];B[pf];W[pg];B[of];W[og];B[qe];W[ng];B[qg];W[rf];B[rg](;W[ri])(;W[re];B[ri];W[rk];B[qj];W[iq];B[ip];W[jp];B[jo];W[kp];B[ir];W[jr];B[jq];W[kq];B[kr];W[js];B[lr];W[iq];B[ko];W[lp];B[jq];W[qh];B[rh];W[iq];B[qr];W[rr];B[jq];W[rj];B[ph];W[iq];B[lo](;W[no])(;W[mo];B[jq];W[pi];B[oh];W[iq];B[cl];W[dk];B[jq](;W[nh])(;W[oi];B[nh];W[iq];B[dc];W[ec];B[jq];W[nk];B[nj];W[iq](;B[eb])(;B[db];W[cb];B[jq](;W[sg])(;W[si](;B[de];W[ed])(;B[oj];W[iq];B[de];W[ed];B[jq];W[sh];B[pj];W[iq];B[sg];W[jq];B[hc];W[ho];B[hn];W[fr];B[gq];W[gr];B[hr];W[hs](;B[il];W[jl])(;B[io];W[il];B[jl];W[hk];B[im];W[ik];B[jk];W[jj];B[kk](;W[lk])(;W[kj];B[lk];W[mk];B[lj];W[mj];B[li];W[mi];B[mh];W[kh];B[ij](;W[hj])(;W[jh];B[hj];W[gk];B[lh];W[km];B[jm];W[kf];B[hh];W[hf];B[ig];W[if];B[jg];W[jf](;B[lg])(;B[kg](;W[je])(;W[ld])(;W[kd];B[ac];W[eb];B[ge];W[hd];B[id];W[he];B[gd];W[gc];B[ff];W[kc];B[hb];W[ab];B[lf];W[le];B[me];W[gg];B[lb](;W[ja])(;W[jb](;B[md])(;B[ld];W[ke];B[kb];W[jc];B[eh];W[lc];B[md];W[mb];B[mc];W[nb];B[ob])))))))))))))))))"

const RecordGame = ( { loadSGFString, style, maxWidth, maxHeight, showCoordinates, stoneMenu, handleStoneMenu, closeStoneMenu, containerRef, rightPanelRef, rightResizerRef, handleRightResize }) => {

  const [state, setState] = useState({}); // game state [gameTrees,gameIndex,gameCurrents]
  const [initialPlayer,setInitialPlayer] = useState('B')
  const [currentPlayer,setCurrentPlayer] = useState('B')
  const [board, setBoard] = useState(emptyBoard); 
  const [boardTree,setBoardTree] = useState({});
  const [treePosition, setTreePosition] = useState(0)
  const [currentMoveNumber, setCurrentMoveNumber] = useState(0);
  const [handicapStones, setHandicapStones] = useState([]); 
  const [gameLength,setGameLength] = useState(0);
  
  useEffect(() => {

    // Initialize state
    const tree = new GameTree()
    const defaultGameIndex = 0
    const gameTrees=[tree]
    const defaultGameCurrents = gameTrees.map(_ => ({})) 

    setState({
        gameTrees: gameTrees,
        gameIndex: defaultGameIndex,
        gameCurrents: defaultGameCurrents, 
      })

  }, []);

  async function handleClickOnFinish() {

    let {gameTrees, gameIndex, gameCurrents} = state
    let tree = gameTrees[gameIndex]

    tree.root.data.KM = [6.5]
    tree.root.data.RU = ['Japanese']
    tree.root.data.PB = ['Black']
    tree.root.data.PW = ['White']

    // Get SGFSTRING from state
    const SGFSTRING = sgf.stringify([tree.root])
    console.debug("sgfstring",SGFSTRING)
    console.debug("root node",tree.root)


    await loadSGFString(SGFSTRING, true)

  };

  // Handle mouse events on the board
  const handleVertexMouseUp = (evt, [x, y]) => { 

    const nextPlayer = currentPlayer
    let sign = nextPlayer === 'B' ? 1 : -1

    const vertex = [x, y]
    try {

      // This will throw an error if the move violates 
      // a ko, is a suicide, or there is already a stone 
      // at that position, cf. board.makeMove() at 
      // https://github.com/SabakiHQ/go-board . 
      let newBoard = board.makeMove(
        sign, 
        vertex,
        { // options
          preventOverwrite:true,
          preventSuicide:true,
          preventKo:true 
        }
      ); 

      let {gameTrees, gameIndex, gameCurrents} = state
      let tree = gameTrees[gameIndex]
      let currents = gameCurrents[gameIndex]

      const dimensions = getGameInfo(tree,currents).size

      let newTree = null

      if(currentMoveNumber < gameLength) {
        newTree = tree.mutate(draft => {
          draft.removeNode(treePosition+1)
        })
        let newBoardTree = {}
        for (let i = 0; i <= currentMoveNumber; i++) {
          newBoardTree[i] = boardTree[i]
        }
        setBoardTree(newBoardTree)
        setGameLength(currentMoveNumber+1)
      } else {
        newTree = tree
        setGameLength(gameLength+1)
      }

      const newNodeId = treePosition + 1
      newTree = newTree.mutate(draft => {
        draft.UNSAFE_appendNodeWithId(treePosition, 
          newNodeId, {
        [nextPlayer]: [sgf.stringifyVertex(vertex)]
        })
      })

      // update game tree
      gameTrees[gameIndex] = newTree
      const newState = {
        gameTrees: gameTrees,
        gameIndex: gameIndex,
        gameCurrents: gameTrees.map(_ => ({})),
      }
  
      setState(newState)
      setCurrentMoveNumber(currentMoveNumber+1)
      setTreePosition(newNodeId)

      // update current player
      setCurrentPlayer(currentPlayer === 'B' ? 'W' : 'B')

      setBoardTree({
        ...boardTree, 
        [newNodeId]: {boardState: newBoard, moveNumber: currentMoveNumber+1 } 
      })
      setBoard(newBoard)

    } catch(err) {
        console.warn(err)
      }
  };

  // Go to next move (if possible) without redrawing board
  const goToNextMove = () => {
    let {gameTrees, gameIndex, gameCurrents} = state
    if (gameTrees === undefined) {
      return
    }
    else { // Game has been uploaded

      let tree = gameTrees[gameIndex]
      let currents = gameCurrents[gameIndex]
      const dimensions = getGameInfo(tree,currents).size

      try {
        let node = tree.navigate(
          treePosition,
          1, // go forward 1 step
          gameCurrents[gameIndex]
        )

        // Make move
        // TODO: implement errors for invalid moves (see board.makeMove on @sabaki/go-board)
        let propData = {B: 1, W: -1}
        let newBoard = null
        let vertex = null

        for (let prop in propData) {
          if (node.data[prop] == null) continue

          vertex = parseVertex(node.data[prop][0])
          newBoard = board.makeMove(
            propData[prop], 
            vertex)
          newBoard.currentVertex = vertex

          break
        }

        setCurrentMoveNumber(currentMoveNumber+1)
        setTreePosition(node.id)

        if (!(node.id in boardTree)) { // update board tree
          boardTree[node.id]={boardState: newBoard, moveNumber: currentMoveNumber+1} 
          setBoardTree(boardTree)
        }

        setBoard(newBoard) // update board

        // update current player
        setCurrentPlayer(currentPlayer === 'B' ? 'W' : 'B')

        return node

      } catch (err) { // No more (valid) moves

        console.warn(err.message)

        return null

        //openDialog('Cannot move to next move.', 'error')
      }
    }
  }

  // Go to previous move (if possible) without redrawing board
  const goToPreviousMove = () => {

    let {gameTrees, gameIndex, gameCurrents} = state
    let tree = gameTrees[gameIndex]
    let currents = gameCurrents[gameIndex]
    const dimensions = getGameInfo(tree,currents).size

  if (gameTrees === undefined) {
    console.log("gameTrees is undefined")
    return
  }
    else {
      if (currentMoveNumber > 0) {
        try {
          let node = tree.navigate(
            treePosition,
            -1, // go backwards 1 step
            gameCurrents[gameIndex]
          )


          if (!!node && node.id in boardTree) {
            const previousBoard = boardTree[node.id].boardState

            setCurrentMoveNumber(currentMoveNumber-1)
            setTreePosition(node.id)
            setBoard(previousBoard)
          }
          else { // Previous move has not been generated yet 
            console.log("node",node,"not found in boardTree. redrawing...")
            redrawThenGoToMove(currentMoveNumber - 1)
          }

          // update current player
          setCurrentPlayer(currentPlayer === 'B' ? 'W' : 'B')

        } catch (err) {
          console.error(err.message)
        }
      } 
    }
  }

  // Redraws entire board up to a specified move number
  const redrawThenGoToMove = (newMoveNumber) => {

    // console.debug("redrawThenGoToMove() called")
    let {gameTrees, gameIndex, gameCurrents} = state
    let tree = gameTrees[gameIndex]
    let currents = gameCurrents[gameIndex]
    const dimensions = getGameInfo(tree,currents).size

    if (gameTrees === undefined) {
      return
    }
    else {

      if (newMoveNumber === -1) { // go to last move
        newMoveNumber=gameLength
      } 

      if (newMoveNumber > gameLength) 
        console.warn("Requested move exceeds game length.");
      
      if (newMoveNumber > 0 && newMoveNumber !== currentMoveNumber) {

            const lastObject=Object.values(boardTree).find(obj => obj.moveNumber === 0);
            let newBoard=lastObject.boardState;
            let newBoardTree=boardTree;

            let i = 0
            let node = tree.root
            while (i < newMoveNumber) {
              try {
                console.debug("Making move.");
                node = tree.navigate(
                  node.id,
                  1, // go forward 1 step
                  gameCurrents[gameIndex]
                )
        
                // Make move
                // TODO: implement errors for invalid moves (see board.makeMove on @sabaki/go-board)
                let propData = {B: 1, W: -1}
                let vertex = null
        
                for (let prop in propData) {
                  if (node.data[prop] == null) continue
        
                  vertex = parseVertex(node.data[prop][0])
                  newBoard = newBoard.makeMove(
                    propData[prop], 
                    vertex)
                  newBoard.currentVertex = vertex
        
                  break
                }

                const storedBoard = newBoard.clone()
        
                if (!(node.id in newBoardTree)) { // update board tree
                  newBoardTree[node.id]={boardState: storedBoard, moveNumber: i+1} 
                }

                i+=1 // increment 

              } catch (err) { // No more (valid) moves
        
                  break; // break out of the while loop
                //openDialog('Cannot move to next move.', 'error')
              }
            }

            setBoard(newBoard)
            setBoardTree(newBoardTree)
            setCurrentMoveNumber(i)
            setTreePosition(node.id)

            setCurrentPlayer(
              initialPlayer === 'B' 
              ? (i % 2 === 0 ? 'B' : 'W')
              : (i % 2 === 0 ? 'W' : 'B')
            )
    
        } else if (newMoveNumber === 0) { 

          // Check for initial/handicap stones 
          let moves = []
          let initialStones = []
          let initialMoves = []
          let initialPlayer = null
          let rootNode = tree.root

          for (let prop of ['B', 'W', 'AB', 'AW']) {
            if (rootNode.data[prop] == null)
              continue
            let color = prop.slice(-1)
            let sign = color === 'B' ? 1 : -1
            let vertices = [].concat(
              ...rootNode.data[prop].map(parseCompressedVertices)
            )

            for (let vertex of vertices) {
              // Convert [2,4] -> "C15" for Katago 
              const gtpVertex=HORIZONTALCOORDS[vertex[0]]+String(dimensions[0] - vertex[1])
              const move = [color,gtpVertex]
              if (prop[0] === 'A') {
                initialStones.push(move)
                initialMoves.push([sign,vertex])
              }
              else {
                moves.push(move)  
              }
            }
          }

        if (initialStones.length > 0) {

          if (initialStones[initialStones.length-1][0] === 'B') {
            initialPlayer = 'W';
            setInitialPlayer(initialPlayer);
            setCurrentPlayer(initialPlayer);
          }

          if (initialStones.every(stone => stone[0] === 'B')) {
            console.log("Found handicap stones:", initialStones.length)
            setHandicapStones(initialStones)
          }

        }

        let newBoard = Board.fromDimensions(dimensions[0], dimensions[1])

        // Play out the initial stones 
        for (let move of initialMoves) {
            newBoard = newBoard.makeMove(move[0], move[1])
          }

        let newBoardTree = boardTree;
        newBoardTree[tree.root.id]={boardState: newBoard, moveNumber: 0} 

        setBoard(newBoard)
        setBoardTree(newBoardTree)
        setCurrentMoveNumber(0)
        setTreePosition(tree.root.id)
      }
    }
  };

  // Program arrow keys to navigate the game
  useEffect(() => {

    const handleKeyDown = (event) => {
      switch (event.key) {
        case "ArrowLeft":
          goToPreviousMove();
          break;
        case "ArrowRight":
          goToNextMove();
          break;
        default:
          break;
      }
    };

    // Add the event listener
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [boardTree,state,currentMoveNumber]); 

  return (
    <div className="content-wrapper">
    {/* Go board */}
    <div className="main-content">
      <div className="player-boxes-container">
      <PlayerBox 
        playerColor = 'B'
        gameInfo = {state.gameTrees ? getGameInfo(state.gameTrees[state.gameIndex],state.gameCurrents[state.gameIndex]) 
                                    : undefined} />  
      <PlayerBox 
        playerColor = 'W'
        gameInfo = {state.gameTrees ? getGameInfo(state.gameTrees[state.gameIndex],state.gameCurrents[state.gameIndex]) 
                                    : undefined} />    
      </div>
      <div className="goban-container" ref={containerRef}>
        <BoundedGoban
          className="goban"
          style={style}
          maxWidth={maxWidth}
          maxHeight={maxHeight}
          signMap={board.signMap}
          showCoordinates={showCoordinates}
          currentMoveNumber={currentMoveNumber}
          stoneMenu={stoneMenu}
          handleStoneMenu={handleStoneMenu}
          closeStoneMenu={closeStoneMenu}
          innerProps={{
            onContextMenu: (evt) => evt.preventDefault(),
          }}
          onVertexMouseUp={handleVertexMouseUp}
        />
      </div>
      {/* {stoneMenu?.visible && 
            <StoneMenu
              x={stoneMenu.x}
              y={stoneMenu.y}
              visible={stoneMenu.visible}
              onClose={closeStoneMenu}
              moveData={stoneMenu.moveData}
              goToMove={redrawThenGoToMove}
            /> 
          } */}
    </div>

    {/* Resizer for Right Panel */}
    <div
      ref={rightResizerRef}
      className="resizer"
      onMouseDown={handleRightResize} >
    </div>

    {/* Right Panel */}
    <div ref={rightPanelRef} className="right-panel">
      {/* <div className="player-boxes-container">   
      </div> */}
      <div className="panel" style="display: flex; align-items: center; justify-content: center;">
          <h3>Recording New Game</h3>
      </div>
      <div className="navigation-bar-container panel">
        <NavigationBar 
          goToNextMove={() => goToNextMove()}
          goToPreviousMove={() => goToPreviousMove()} 
          redrawThenGoToMove={(move) => redrawThenGoToMove(move)} />
      </div>
      <div style="display: flex; width: 80%; align-items: center; justify-content: center; margin: 20px;">
        <button onClick={handleClickOnFinish}>Submit for analysis</button>
      </div>
    </div>
  </div>
  );
};

export default RecordGame;